<ion-app>
    <ion-split-pane contentId="main-content">
        <app-menu></app-menu>

        <app-loader></app-loader>
        <app-cookie-banner></app-cookie-banner>

        <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>